var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFenced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 59,
    viewBox: "0 0 35 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 2,
    y: 2,
    width: 31,
    height: 55,
    rx: 11,
    stroke: "#F9A825",
    strokeWidth: 4,
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.038 40.5983C27.3339 40.8255 27.5158 41.178 27.5158 41.6017V47.2704C27.5158 47.6463 27.3673 47.9968 27.0774 48.2412C27.0086 48.2994 26.94 48.3468 26.8716 48.3853L26.8712 48.4044C26.8634 48.7655 26.798 49.1202 26.6754 49.4595C25.6024 52.4199 20.8238 53.1098 18.1324 53.1154C15.4368 53.1208 10.6777 52.4513 9.58028 49.5011C9.44926 49.1478 9.38027 48.7788 9.37331 48.4036L9.37271 48.3784C8.98561 48.1706 8.72894 47.7889 8.72894 47.2706V41.6019C8.72894 41.2058 8.89356 40.8396 9.2065 40.5977L8.87726 25.1806L7.44717 25.5637L7.14636 24.6992C6.72347 23.4847 7.24875 22.691 8.31302 22.2824C8.28399 22.1725 8.26828 22.0548 8.26828 21.9303V16.2614C8.26828 15.8575 8.42137 15.5409 8.66651 15.3236L8.6514 14.6168C8.63888 14.0186 8.89654 13.3818 9.18403 12.8398C9.26137 12.0181 9.88645 11.0831 10.3318 10.5061C10.8296 9.86033 11.6889 8.89547 12.6019 8.75252C13.1278 8.35489 13.7592 8 14.4101 8H21.8344C22.4891 8 23.1241 8.35926 23.6512 8.75948C24.5486 8.91516 25.4123 9.86113 25.9117 10.4987C26.3726 11.0866 26.9869 12.0165 27.0597 12.8388C27.347 13.3812 27.6058 14.0186 27.5933 14.617L27.578 15.3238C27.8233 15.5411 27.976 15.8577 27.976 16.2616V21.9305C27.976 22.05 27.9611 22.1667 27.9315 22.2781C28.3615 22.4411 28.7538 22.6791 29.0087 23.0926C29.3 23.5654 29.3033 24.1102 29.1248 24.6239L28.7975 25.5639L27.3676 25.1808L27.038 40.5983Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.872 40.6811C27.1676 40.8754 27.3511 41.2002 27.3511 41.6014V47.2701C27.3511 47.5974 27.2241 47.9027 26.972 48.1155C26.8841 48.1892 26.797 48.2433 26.7095 48.2829L26.7072 48.4006C26.6998 48.7439 26.6376 49.0809 26.5207 49.4032C25.4779 52.2805 20.7408 52.9451 18.132 52.9507C15.5187 52.9561 10.801 52.3111 9.73433 49.4436C9.60928 49.1078 9.54406 48.7567 9.5373 48.4002L9.53472 48.2747C9.15299 48.1065 8.89294 47.7622 8.89294 47.2701V41.6014C8.89294 41.24 9.04762 40.908 9.34624 40.6982C9.35519 40.692 9.36374 40.6861 9.37249 40.6803L9.03688 24.9674L7.55192 25.365L7.30141 24.6447C6.88926 23.4606 7.44038 22.742 8.51996 22.382C8.46349 22.2474 8.43268 22.0961 8.43268 21.9299V16.2612C8.43268 15.8765 8.58795 15.587 8.8325 15.3993L8.8158 14.6132C8.80327 14.0364 9.06472 13.41 9.34425 12.8875C9.4031 12.0972 10.0377 11.1558 10.4618 10.6058C10.9296 9.99905 11.7881 9.02067 12.6665 8.90934C13.1701 8.52323 13.7868 8.16357 14.4103 8.16357H21.8345C22.4612 8.16357 23.0805 8.52661 23.5849 8.91431C24.448 9.03877 25.3117 9.99826 25.7829 10.5997C26.2234 11.1615 26.8457 12.095 26.8992 12.8859C27.1791 13.4088 27.4416 14.0358 27.4293 14.6132L27.4124 15.3993C27.6569 15.587 27.812 15.8765 27.812 16.2612V21.9301C27.812 22.0873 27.7829 22.2392 27.7251 22.3778C28.1794 22.5301 28.608 22.7546 28.8691 23.178C29.1343 23.6083 29.1319 24.1027 28.9701 24.5694L28.6927 25.3652L27.208 24.9676L26.872 40.6811Z",
    fill: "#E9E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7059 40.7732C27.0008 40.9301 27.1873 41.2241 27.1873 41.6015V47.2701C27.1873 47.5489 27.0817 47.8083 26.8664 47.9897C26.7608 48.0785 26.6554 48.1342 26.5479 48.1686L26.5429 48.3968C26.5361 48.7223 26.4773 49.0414 26.3664 49.3474C25.8735 50.7077 24.476 51.5209 23.1861 51.9885C21.6128 52.5589 19.799 52.7829 18.1316 52.7865C16.4667 52.7897 14.6558 52.5742 13.083 52.0119C11.7899 51.5493 10.3924 50.7423 9.8882 49.386C9.76951 49.0675 9.70767 48.7352 9.70151 48.3964L9.69674 48.1614C9.32097 48.036 9.05754 47.734 9.05754 47.2699V41.6013C9.05754 41.2933 9.18598 41.0114 9.44086 40.8321C9.47367 40.8096 9.50607 40.7889 9.53868 40.7714L9.19651 24.7547L7.65687 25.167L7.45647 24.5909C7.30894 24.1668 7.26063 23.7161 7.4841 23.3075C7.72964 22.8584 8.20183 22.6488 8.66846 22.5071C8.69907 22.4975 8.72969 22.4886 8.76091 22.4796C8.65673 22.3309 8.59708 22.1452 8.59708 21.9297V16.2612C8.59708 15.8972 8.75534 15.6381 8.99869 15.4829L8.9798 14.6097C8.96807 14.0546 9.23409 13.4368 9.50567 12.9342C9.54285 12.1801 10.19 11.2274 10.592 10.7061C11.028 10.1408 11.8909 9.14279 12.7303 9.06783C13.2108 8.69366 13.8146 8.32764 14.4105 8.32764H21.8347C22.4304 8.32764 23.0338 8.69346 23.5137 9.06684C24.013 9.11137 24.4871 9.48595 24.8351 9.80942C25.1244 10.0786 25.4095 10.3892 25.6534 10.7007C26.0725 11.2355 26.7053 12.1765 26.7378 12.9318C27.0099 13.4349 27.2769 14.0538 27.2652 14.6095L27.2461 15.4827C27.4895 15.6383 27.6479 15.8972 27.6479 16.261V21.9299C27.6479 22.1287 27.5941 22.3174 27.4863 22.4747C27.9706 22.6158 28.4573 22.823 28.7293 23.2642C28.9681 23.6517 28.9605 24.096 28.8146 24.5153L28.5877 25.1672L27.0483 24.7549L26.7059 40.7732Z",
    fill: "#DDE0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5395 40.8777C26.8335 40.9918 27.023 41.2497 27.023 41.602V47.2707C27.023 47.5009 26.9385 47.7148 26.7602 47.8647C26.6397 47.9665 26.5156 48.0162 26.3862 48.0403L26.3788 48.394C26.3721 48.7016 26.3166 49.003 26.212 49.2918C25.7371 50.6017 24.37 51.3856 23.13 51.8349C21.575 52.399 19.7791 52.6198 18.1307 52.623C16.4855 52.6266 14.6926 52.4137 13.138 51.8574C11.8948 51.4128 10.5274 50.6354 10.0416 49.3294C9.92971 49.028 9.87145 48.7139 9.86529 48.3936L9.85793 48.0371C9.49072 47.9572 9.22132 47.7047 9.22132 47.2707V41.602C9.22132 41.3481 9.32391 41.1155 9.53466 40.9672C9.59132 40.928 9.64759 40.898 9.70465 40.8759L9.35572 24.5427L7.76121 24.9698L7.6109 24.5375C7.47929 24.1596 7.42779 23.7524 7.6276 23.387C7.84929 22.9808 8.29464 22.7927 8.71553 22.6647C8.83462 22.6283 8.95451 22.5957 9.07499 22.5643C8.88035 22.4297 8.76086 22.2134 8.76086 21.9304V16.2616C8.76086 15.92 8.9231 15.6965 9.16426 15.577L9.14358 14.6066C9.13185 14.073 9.40423 13.4612 9.66747 12.9795C9.67999 12.2679 10.3432 11.2971 10.7216 10.8066C11.1232 10.2859 11.9988 9.26022 12.7909 9.22841C13.2478 8.86775 13.8414 8.49219 14.4101 8.49219H21.8343C22.4029 8.49219 22.9966 8.86775 23.4529 9.22801C23.929 9.24769 24.4 9.62982 24.7231 9.93003C25.0062 10.1929 25.2853 10.4975 25.5241 10.8022C25.9208 11.3082 26.5671 12.2628 26.5749 12.9769C26.8387 13.459 27.1121 14.0718 27.1009 14.6062L27.0803 15.5766C27.3212 15.6965 27.4837 15.9198 27.4837 16.2612V21.93C27.4837 22.174 27.389 22.3983 27.1922 22.548C27.187 22.5521 27.1811 22.5563 27.1755 22.5605C27.6934 22.6933 28.2956 22.8732 28.5893 23.3504C28.802 23.6951 28.7889 24.0896 28.6597 24.4616L28.4827 24.9696L26.8884 24.5425L26.5395 40.8777Z",
    fill: "#D5D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3726 40.9982C26.666 41.0642 26.8589 41.2778 26.8589 41.6016V47.2703C26.8589 47.452 26.7955 47.6202 26.6545 47.7389C26.5229 47.8501 26.377 47.8849 26.2255 47.895L26.2145 48.3901C26.2086 48.6797 26.1561 48.9632 26.0577 49.2354C25.6016 50.4939 24.2637 51.2488 23.074 51.6803C21.5374 52.2378 19.7593 52.4549 18.1306 52.4582C16.5045 52.4618 14.7299 52.2521 13.1932 51.7023C12.0003 51.2757 10.6625 50.5269 10.1956 49.2714C10.0903 48.9879 10.035 48.6917 10.0296 48.3895L10.0189 47.8952C9.66459 47.8634 9.38525 47.6723 9.38525 47.2699V41.6012C9.38525 41.4008 9.46219 41.2179 9.6292 41.1006C9.70793 41.0455 9.78845 41.0143 9.87176 40.997L9.51568 24.3292L7.86649 24.7712L7.76608 24.4831C7.43585 23.5345 7.88856 23.0872 8.76335 22.8214C8.99994 22.7494 9.24051 22.6919 9.47929 22.6269L9.4775 22.5458C9.15244 22.4961 8.92499 22.2856 8.92499 21.9299V16.2614C8.92499 15.9445 9.09418 15.7642 9.33097 15.6846L9.30771 14.6031C9.29698 14.0903 9.5779 13.4813 9.83179 13.0221C9.8141 12.362 10.4986 11.3647 10.8515 10.9069C11.2166 10.4341 12.1156 9.3702 12.8492 9.39207C13.2807 9.04593 13.8686 8.65625 14.4104 8.65625H21.8346C22.3768 8.65625 22.9649 9.04653 23.3953 9.39207C23.8422 9.38054 24.3164 9.77599 24.6117 10.0504C24.8884 10.3078 25.162 10.6057 25.3952 10.9039C25.7662 11.3775 26.4314 12.3556 26.411 13.0193C26.6654 13.479 26.9478 14.0895 26.937 14.6033L26.9138 15.6848C27.1504 15.7644 27.3197 15.9449 27.3197 16.2616V21.9305C27.3197 22.1229 27.2488 22.2993 27.0927 22.4178C26.9885 22.4971 26.8802 22.5315 26.7668 22.5462L26.7652 22.6261C26.8658 22.6522 26.9666 22.6768 27.0672 22.7023C27.5482 22.8244 28.1721 22.9862 28.4494 23.4365C28.6355 23.7383 28.6172 24.0835 28.5045 24.4077L28.3777 24.7716L26.7287 24.3296L26.3726 40.9982Z",
    fill: "#CDCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2053 41.1412C26.2305 41.1424 26.2558 41.1448 26.2816 41.1486C26.5323 41.184 26.6946 41.3361 26.6946 41.6017V47.2704C26.6946 47.4032 26.6522 47.5262 26.5488 47.6133C26.4131 47.7278 26.2361 47.7376 26.0643 47.7356L26.0506 48.3867C26.0448 48.6581 25.9959 48.9245 25.9035 49.1796C25.4659 50.3864 24.1569 51.1131 23.0179 51.5262C21.4991 52.0768 19.7396 52.2911 18.1301 52.2941C16.5235 52.2976 14.7669 52.0913 13.2486 51.5483C12.1058 51.1393 10.7972 50.4186 10.3494 49.2146C10.2502 48.9482 10.1987 48.6702 10.1936 48.3867L10.1794 47.736C10.1504 47.7368 10.121 47.7368 10.0914 47.7356C9.79612 47.7258 9.54939 47.6056 9.54939 47.2704V41.6017C9.54939 41.455 9.60068 41.3217 9.72375 41.2355C9.81978 41.1679 9.92794 41.1478 10.0389 41.1414L9.67504 24.1171L7.97138 24.5734L7.92108 24.4292C7.62345 23.5741 8.02685 23.2171 8.81138 22.9785C9.08754 22.8942 9.36886 22.83 9.64601 22.7512L9.63826 22.3936C9.60903 22.3932 9.57921 22.392 9.54939 22.3892C9.27979 22.3643 9.08933 22.2198 9.08933 21.9299V16.2614C9.08933 15.9724 9.26886 15.8481 9.49809 15.8113L9.47205 14.5993C9.46131 14.1065 9.75457 13.4955 9.99812 13.0607C9.94245 12.4636 10.6546 11.4314 10.9819 11.0073C11.3065 10.586 12.2457 9.46885 12.9022 9.56071C13.3044 9.23167 13.8939 8.82031 14.4103 8.82031H21.8345C22.3514 8.82031 22.9415 9.23306 23.3429 9.56091C23.9805 9.48237 24.9327 10.5794 25.2661 11.0051C25.6116 11.4459 26.3013 12.4543 26.2445 13.0573C26.4884 13.4923 26.7835 14.1055 26.7727 14.5995L26.7469 15.8115C26.9757 15.8483 27.1554 15.973 27.1554 16.2616V21.9305C27.1554 22.0713 27.1081 22.2001 26.9938 22.287C26.8783 22.3749 26.7431 22.3912 26.6065 22.3936L26.599 22.7514C26.7409 22.7908 26.8847 22.8254 27.0274 22.8616C27.4557 22.9703 28.0626 23.1216 28.3102 23.523C28.4694 23.7813 28.446 24.0777 28.3499 24.3541L28.2732 24.5738L26.5695 24.1175L26.2053 41.1412Z",
    fill: "#C5C5C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0377 41.3027C26.2025 41.3027 26.5306 41.2763 26.5306 41.6013V47.27C26.5306 47.6269 26.1292 47.5686 25.9041 47.5686L25.8864 48.383C25.78 53.3586 10.45 53.3993 10.3578 48.383L10.3403 47.5686C10.115 47.5686 9.71363 47.6269 9.71363 47.27V41.6013C9.71363 41.2763 10.0415 41.3027 10.2065 41.3027L9.83491 23.904L8.07637 24.375C7.82109 23.6422 8.12448 23.3589 8.85931 23.1352C9.17503 23.0392 9.49652 22.9688 9.81284 22.8733L9.79892 22.2286C9.61621 22.2286 9.25317 22.2709 9.25317 21.93V16.2611C9.25317 15.9897 9.48678 15.9627 9.66532 15.9627L9.63629 14.5954C9.62714 14.186 9.85936 13.6359 10.1703 13.0894L10.1685 13.0923C10.0017 12.2714 12.1424 9.46034 12.9442 9.73849L12.9384 9.74306C13.4494 9.3156 13.9844 8.98438 14.4103 8.98438H21.8345C22.2588 8.98438 22.7906 9.31282 23.2998 9.73769C23.8314 9.55737 24.8683 10.7632 25.1365 11.1058C25.4248 11.4738 26.1799 12.5514 26.0741 13.0896C26.385 13.6361 26.6171 14.1868 26.6085 14.5956L26.5793 15.9629C26.758 15.9629 26.9912 15.9901 26.9912 16.2613V21.9302C26.9912 22.2711 26.6286 22.2288 26.4455 22.2288L26.4318 22.8735C27.3042 23.137 28.5679 23.227 28.1949 24.2997L28.1682 24.3754L26.4097 23.9044L26.0377 41.3027Z",
    fill: "#BBBDBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6388 46.3154V40.6464C24.6388 40.4821 24.7728 40.3481 24.937 40.3481H25.5313C25.6955 40.3481 25.8297 40.4821 25.8297 40.6464V46.3154C25.8297 46.4797 25.6955 46.6137 25.5313 46.6137H24.937C24.7728 46.6137 24.6388 46.4797 24.6388 46.3154ZM9.01318 46.3154V40.6464C9.01318 40.4821 9.14699 40.3481 9.31141 40.3481H9.90567C10.0699 40.3481 10.2041 40.4821 10.2041 40.6464V46.3154C10.2041 46.4797 10.0699 46.6137 9.90567 46.6137H9.31141C9.14679 46.6137 9.01318 46.4797 9.01318 46.3154Z",
    fill: "#414142"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7471 46.316V40.6469C24.7471 40.5425 24.8326 40.457 24.9371 40.457H25.5314C25.636 40.457 25.7219 40.5425 25.7219 40.6469V46.316C25.7219 46.4204 25.636 46.5058 25.5314 46.5058H24.9371C24.8326 46.5058 24.7471 46.4204 24.7471 46.316Z",
    fill: "url(#paint0_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12158 46.317V40.6479C9.12158 40.5435 9.20707 40.458 9.31165 40.458H9.90592C10.0105 40.458 10.0958 40.5435 10.0958 40.6479V46.317C10.0958 46.4213 10.0105 46.5068 9.90592 46.5068H9.31165C9.20687 46.5068 9.12158 46.4213 9.12158 46.317Z",
    fill: "url(#paint1_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0992 20.9751V15.3062C25.0992 15.142 25.2334 15.0078 25.3976 15.0078H25.9919C26.1559 15.0078 26.2903 15.142 26.2903 15.3062V20.9751C26.2903 21.1395 26.1559 21.2735 25.9919 21.2735H25.3976C25.2334 21.2733 25.0992 21.1395 25.0992 20.9751ZM8.55225 20.9751V15.3062C8.55225 15.142 8.68645 15.0078 8.85087 15.0078H9.44513C9.60936 15.0078 9.74336 15.142 9.74336 15.3062V20.9751C9.74336 21.1395 9.60936 21.2735 9.44513 21.2735H8.85087C8.68645 21.2733 8.55225 21.1395 8.55225 20.9751Z",
    fill: "#414142"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2075 20.9754V15.3065C25.2075 15.2019 25.293 15.1162 25.3976 15.1162H25.9919C26.0962 15.1162 26.1819 15.2019 26.1819 15.3065V20.9754C26.1819 21.0799 26.0962 21.1654 25.9919 21.1654H25.3976C25.2928 21.1654 25.2075 21.0799 25.2075 20.9754Z",
    fill: "url(#paint2_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66064 20.9758V15.307C8.66064 15.2024 8.74633 15.1167 8.85091 15.1167H9.44518C9.54956 15.1167 9.63505 15.2024 9.63505 15.307V20.9758C9.63505 21.0804 9.54956 21.1659 9.44518 21.1659H8.85091C8.74633 21.1659 8.66064 21.0804 8.66064 20.9758Z",
    fill: "url(#paint3_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4362 10.1507C24.1306 9.76087 23.7563 9.35309 23.3565 9.05845C23.1851 8.9316 22.8383 8.69958 22.5972 8.78348C23.2332 9.31393 23.8334 9.99488 24.1444 10.374C24.4617 10.7603 24.9804 11.4458 25.3729 12.1371C25.482 11.6003 24.7247 10.5192 24.4362 10.1507Z",
    fill: "#FFCB0A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3502 10.2175C23.7206 9.41389 23.0368 8.86635 22.7036 8.8741C23.2993 9.38944 23.8508 10.0161 24.144 10.3742C24.4343 10.7277 24.8934 11.3317 25.2699 11.9611C25.2312 11.5756 24.8852 10.9001 24.3502 10.2175Z",
    fill: "#FEFAD6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4044 10.1507C10.71 9.76087 11.0844 9.35309 11.484 9.05845C11.6554 8.9316 12.0021 8.69958 12.2435 8.78348C11.6077 9.31393 11.0072 9.99488 10.6963 10.374C10.379 10.7603 9.86025 11.4458 9.46739 12.1371C9.35863 11.6003 10.1159 10.5192 10.4044 10.1507Z",
    fill: "#FFCB0A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4896 10.2175C11.1195 9.41389 11.8032 8.86635 12.1364 8.8741C11.5408 9.38944 10.9893 10.0161 10.696 10.3742C10.4055 10.7277 9.94667 11.3317 9.57031 11.9611C9.60908 11.5756 9.95502 10.9001 10.4896 10.2175Z",
    fill: "#FEFAD6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65721 47.4285L8.9353 13.6409C8.91542 12.7146 10.1282 11.0662 10.696 10.3743C11.2561 9.69141 12.7552 8.0293 13.7093 8.0293H21.1339C22.0876 8.0293 23.5867 9.69161 24.1466 10.3743C24.714 11.066 25.9276 12.715 25.9077 13.6409L25.1858 47.4285C25.0796 52.4033 9.74966 52.4448 9.65721 47.4285Z",
    fill: "#808184"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76512 47.4257L9.04342 13.6381C9.0132 12.2249 12.335 8.13721 13.7093 8.13721H21.1339C22.5079 8.13721 25.8295 12.2257 25.7995 13.6381L25.0778 47.4257C24.9744 52.2561 9.85519 52.2969 9.76512 47.4257Z",
    fill: "url(#paint4_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1407 8.85997C21.3851 8.88621 21.8768 9.26198 22.073 9.42521C22.5977 9.86082 23.0728 10.3742 23.5051 10.9008C23.9341 11.4239 24.3391 11.9836 24.6688 12.5755C24.8004 12.8115 25.0835 13.3632 25.0781 13.623L25.0779 13.6262L24.5968 19.9693L24.462 19.9198C19.5315 18.1026 15.3116 18.1028 10.3814 19.9198L10.2466 19.9693L9.76522 13.626V13.6228C9.75965 13.3626 10.0428 12.8113 10.1744 12.5749C10.504 11.9834 10.9084 11.4237 11.3381 10.9004C11.7701 10.374 12.2455 9.86082 12.7699 9.42521C12.9662 9.26218 13.4586 8.88582 13.7026 8.85997L13.7082 8.85938H13.7139C16.1854 8.85938 18.6573 8.85938 21.129 8.85938H21.1348L21.1407 8.85997Z",
    fill: "#A6A8AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.129 8.96777C18.6573 8.96777 16.1854 8.96777 13.7139 8.96777C13.499 8.99044 13.0002 9.37475 12.8393 9.50856C12.3248 9.93562 11.8452 10.4529 11.4217 10.9695C11.0001 11.483 10.5923 12.0469 10.269 12.6278C10.1571 12.8286 9.86838 13.3881 9.87335 13.6209L10.3436 19.8182C15.3029 17.9907 19.5404 17.9907 24.4995 19.8182L24.9695 13.6209C24.9743 13.3885 24.686 12.8286 24.5743 12.628C24.25 12.0473 23.8426 11.4832 23.4211 10.9695C22.9977 10.4531 22.5177 9.93581 22.0036 9.50875C21.8427 9.37475 21.3439 8.99044 21.129 8.96777Z",
    fill: "url(#paint5_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5833 25.3894C11.2757 23.4949 10.9679 22.1224 10.6606 20.2281C10.6315 20.0494 10.7369 19.8788 10.9099 19.8255C15.2528 18.4787 19.5958 18.3948 23.939 19.8217C24.1089 19.8776 24.2111 20.0458 24.1825 20.2225C23.8747 22.119 23.5664 23.4931 23.2588 25.3894C23.2429 25.4884 23.1936 25.5675 23.1121 25.6258C23.0304 25.6836 22.9395 25.7043 22.8407 25.6872C19.2278 25.0599 15.6145 25.0599 12.0016 25.6872C11.903 25.7043 11.8121 25.6836 11.7304 25.6258C11.6489 25.5675 11.5994 25.4884 11.5833 25.3894Z",
    fill: "url(#paint6_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5834 25.3897C11.2759 23.4952 10.9683 22.1227 10.6605 20.2284C10.6436 20.1246 10.6725 20.0236 10.7333 19.9467C15.0514 18.6219 19.3695 18.5468 23.6876 19.9659C23.8576 20.0216 23.96 20.19 23.9312 20.3666C23.6234 22.2631 23.3154 23.6373 23.0075 25.5334C22.9977 25.5937 22.9757 25.6464 22.9417 25.6915C22.9087 25.6951 22.8757 25.6937 22.8409 25.6875C19.2278 25.0602 15.6145 25.0602 12.0016 25.6875C11.9031 25.7046 11.8121 25.6839 11.7304 25.6261C11.6491 25.5678 11.5997 25.4887 11.5834 25.3897Z",
    fill: "url(#paint7_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.537 32.6801V32.8773C11.537 34.9287 11.537 36.9803 11.537 39.0321V39.5459C11.537 40.0266 11.5481 40.5073 11.5544 40.9881C11.5656 41.8277 11.5733 42.718 11.4479 43.5486C11.3509 44.1936 11.1431 44.9688 10.5761 45.3613L10.1347 45.6664L10.123 45.1302C10.0872 43.4818 10.0514 41.8338 10.0154 40.1858L10.0138 40.1077L10.0516 40.0397C10.1619 39.8401 10.3367 39.6968 10.5321 39.5802C10.3836 39.5884 10.2411 39.5596 10.117 39.4691L10.0017 39.3852L9.99831 39.2423C9.95079 37.0483 9.89651 34.8544 9.84919 32.6604L9.84721 32.5847L9.88299 32.5179C9.96232 32.3692 10.1035 32.3101 10.2705 32.3027C10.0438 32.1902 9.86609 32.0282 9.83806 31.7665L9.83687 31.7544L9.83647 31.7423C9.76748 28.5656 9.69412 25.3891 9.62513 22.2124L9.60962 21.499L10.1168 22.0008C10.588 22.4669 10.8848 23.5556 11.0302 24.1835C11.3435 25.538 11.4803 26.9917 11.5364 28.3783L11.5368 28.3841V28.3898C11.5368 29.699 11.5368 31.0079 11.5368 32.3169V32.6801H11.537ZM24.5716 32.3031C24.7386 32.3105 24.8802 32.3695 24.9595 32.5183L24.9951 32.5851L24.9933 32.6608C24.9462 34.8548 24.8917 37.0487 24.8438 39.2427L24.8406 39.3856L24.7251 39.4695C24.6012 39.56 24.4587 39.5888 24.3106 39.5806C24.5058 39.6972 24.6806 39.8405 24.7911 40.0401L24.8289 40.1081L24.8269 40.1862C24.7911 41.8342 24.7553 43.4822 24.7195 45.1306L24.7082 45.6664L24.267 45.3613C23.6996 44.9686 23.4924 44.1936 23.3948 43.5486C23.2697 42.718 23.2773 41.8277 23.2884 40.9881C23.2948 40.5073 23.3059 40.0266 23.3059 39.5459V39.0321C23.3059 36.9803 23.3059 34.9287 23.3059 32.8773V32.3175C23.3059 31.0084 23.3059 29.6996 23.3059 28.3904V28.3847L23.3061 28.3789C23.3624 26.9923 23.499 25.5386 23.8125 24.184C23.9577 23.5564 24.2547 22.4675 24.7255 22.0014L25.2331 21.4996L25.2174 22.213C25.1484 25.3899 25.0746 28.5662 25.006 31.7429L25.0056 31.755L25.0042 31.7671C24.9764 32.0286 24.7985 32.1904 24.5716 32.3031Z",
    fill: "url(#paint8_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2876 39.2361C10.2377 36.94 10.1878 34.951 10.1379 32.6545C10.2475 32.4499 10.9793 32.7722 11.2481 32.8774C11.2481 34.9288 11.2481 36.9804 11.2481 39.0322C10.9748 39.165 10.5143 39.4016 10.2876 39.2361Z",
    fill: "url(#paint9_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4116 45.1241C10.3756 43.4757 10.3402 41.8277 10.3044 40.1797C10.4794 39.8632 10.98 39.6757 11.248 39.5459C11.248 41.6941 11.4836 44.3819 10.4116 45.1241Z",
    fill: "url(#paint10_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5554 39.2361C24.6051 36.94 24.655 34.951 24.7049 32.6545C24.5958 32.4499 23.8635 32.7722 23.5947 32.8774C23.5947 34.9288 23.5947 36.9804 23.5947 39.0322C23.8683 39.165 24.3284 39.4016 24.5554 39.2361Z",
    fill: "url(#paint11_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4311 45.1241C24.4669 43.4757 24.5027 41.8277 24.5385 40.1797C24.3637 39.8632 23.8629 39.6757 23.5947 39.5459C23.5947 41.6941 23.3591 44.3819 24.4311 45.1241Z",
    fill: "url(#paint12_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7172 31.7364C24.7876 28.4886 24.8582 25.4546 24.9286 22.2065C24.3441 22.7849 23.7315 25.0128 23.5947 28.3904C23.5947 29.6996 23.5947 31.0084 23.5947 32.3174C23.9224 32.2037 24.6785 32.1015 24.7172 31.7364Z",
    fill: "url(#paint13_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1256 31.7364C10.055 28.4886 9.98444 25.4546 9.91406 22.2065C10.4988 22.7849 11.1111 25.0128 11.2479 28.3904C11.2479 29.6996 11.2479 31.0084 11.2479 32.3174C10.9203 32.2037 10.1648 32.1015 10.1256 31.7364Z",
    fill: "url(#paint14_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2375 48.6951C10.9695 48.4466 10.9395 48.0498 10.9949 47.7072C11.058 47.3162 11.2369 46.9169 11.4584 46.5909C11.5429 46.4674 11.6363 46.3493 11.7387 46.2402L12.0264 45.9346L12.2091 46.3123C12.4491 46.8086 13.4964 47.1203 13.9828 47.2408C15.0751 47.5118 16.2908 47.6108 17.4127 47.6178C18.5363 47.6108 19.752 47.5118 20.8443 47.2408C21.3304 47.1205 22.3782 46.8086 22.618 46.3123L22.8007 45.9346L23.0882 46.2402C23.191 46.3493 23.2842 46.4674 23.3683 46.5909C23.5902 46.9171 23.7689 47.3162 23.8322 47.7072C23.8874 48.0498 23.8578 48.4466 23.5896 48.6951C23.023 49.4415 21.9722 49.8733 21.0996 50.1191C19.9272 50.4491 18.6367 50.5785 17.4203 50.5795H17.405C16.1896 50.5783 14.8997 50.4487 13.7275 50.1191C12.8549 49.8733 11.8039 49.4415 11.2375 48.6951Z",
    fill: "#DBDCDD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4139 47.9066C14.9084 47.8911 12.4066 47.3831 11.9496 46.4375C11.341 47.0845 11.0362 48.1503 11.4511 48.4986C12.3305 49.6907 14.867 50.288 17.4061 50.2908H17.4139H17.4216C19.9611 50.288 22.4968 49.6907 23.3764 48.4986C23.7917 48.1503 23.4865 47.0845 22.8779 46.4375C22.4209 47.3831 19.9192 47.8911 17.4139 47.9066Z",
    fill: "url(#paint15_radial)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34918 23.3448C7.27084 23.1195 7.24003 22.8726 7.36687 22.6586C7.52414 22.3934 7.87863 22.2654 8.15836 22.1805C8.53572 22.0656 8.92162 21.9874 9.29639 21.8592C9.43219 21.8131 9.56579 21.7606 9.69542 21.6984L9.78906 21.6528L9.8163 21.7534C9.89324 22.0407 9.96999 22.328 10.0469 22.6151L10.0692 22.6986L9.98589 22.7209C9.14171 22.9471 8.29714 23.1732 7.45316 23.3994L7.37542 23.4201L7.34918 23.3448Z",
    fill: "#A6A8AC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43104 23.3171C7.03221 22.1707 8.60207 22.322 9.73314 21.7769C9.81009 22.0641 9.88683 22.3514 9.96397 22.6383C9.1194 22.8646 8.27542 23.0908 7.43104 23.3171Z",
    fill: "#F2F2F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82326 22.7652L9.54932 21.7432L9.20346 21.8359L9.4774 22.8579L9.82326 22.7652Z",
    fill: "#A6A8AC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71769 22.7046L9.48853 21.8496L9.30955 21.8976L9.53871 22.7525L9.71769 22.7046Z",
    fill: "#D1D2D3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4939 23.3448C27.5722 23.1195 27.6026 22.8726 27.4758 22.6586C27.3191 22.3934 26.9642 22.2654 26.6847 22.1805C26.3073 22.0656 25.9212 21.9874 25.5468 21.8592C25.4108 21.8131 25.2768 21.7606 25.148 21.6984L25.0536 21.6528L25.0267 21.7534C24.9496 22.0407 24.873 22.328 24.7959 22.6151L24.7734 22.6986L24.8567 22.7209C25.7015 22.9471 26.5457 23.1732 27.3901 23.3994L27.4674 23.4201L27.4939 23.3448Z",
    fill: "#A6A8AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4124 23.3166C27.811 22.1702 26.2413 22.3215 25.1103 21.7764C25.0333 22.0637 24.9566 22.3509 24.8796 22.6378C25.7236 22.8641 26.568 23.0903 27.4124 23.3166Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3668 22.8569L25.6401 21.835L25.2948 21.7426L25.0215 22.7645L25.3668 22.8569Z",
    fill: "#A6A8AC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3031 22.7524L25.5325 21.8975L25.3533 21.8494L25.124 22.7043L25.3031 22.7524Z",
    fill: "#D1D2D3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67715 31.2522C9.67536 31.1093 9.64335 30.5103 9.77239 30.5103H9.89128L9.91355 31.6463C9.7529 31.6624 9.67994 31.4407 9.67715 31.2522Z",
    fill: "#929497"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88026 31.5926C9.74586 31.6058 9.71167 31.3523 9.71027 31.2521C9.70829 31.1111 9.68801 30.5532 9.7737 30.5532C9.79398 30.5532 9.80988 30.5532 9.85998 30.5532C9.86694 30.9041 9.8735 31.2417 9.88026 31.5926Z",
    fill: "url(#paint16_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82495 38.7898C9.82296 38.6469 9.79115 38.0479 9.92018 38.0479H10.0393L10.0613 39.1841C9.9005 39.2 9.82733 38.9783 9.82495 38.7898Z",
    fill: "#929497"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0281 39.131C9.8935 39.1445 9.85911 38.891 9.85811 38.7908C9.85593 38.6499 9.83565 38.0918 9.92154 38.0918C9.94162 38.0918 9.95772 38.0918 10.0078 38.0918C10.0146 38.4429 10.0211 38.7805 10.0281 39.131Z",
    fill: "url(#paint17_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1654 31.2518C25.1672 31.1088 25.1992 30.5098 25.0702 30.5098H24.9515L24.9294 31.6458C25.0897 31.6619 25.1629 31.4402 25.1654 31.2518Z",
    fill: "#929497"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9619 31.5931C25.0967 31.6063 25.1311 31.3528 25.1323 31.2526C25.1343 31.1116 25.1548 30.5537 25.0689 30.5537C25.0484 30.5537 25.0323 30.5537 24.9822 30.5537C24.9756 30.9046 24.9689 31.2422 24.9619 31.5931Z",
    fill: "url(#paint18_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0181 38.7903C25.0199 38.6474 25.0519 38.0483 24.9229 38.0483H24.8042L24.7817 39.1846C24.9424 39.2005 25.0153 38.9788 25.0181 38.7903Z",
    fill: "#929497"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8154 39.132C24.9498 39.1455 24.9844 38.892 24.9856 38.7918C24.9876 38.6509 25.0079 38.0928 24.9222 38.0928C24.9019 38.0928 24.8858 38.0928 24.8357 38.0928C24.8289 38.4439 24.8224 38.7815 24.8154 39.132Z",
    fill: "url(#paint19_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8798 46.152C11.8009 39.5262 11.9319 29.2923 11.6428 26.0657C15.4637 25.3577 19.3798 25.3577 23.2007 26.0657C22.9112 29.2923 23.0424 39.5262 22.9639 46.152C22.9824 48.5819 11.8607 48.5819 11.8798 46.152Z",
    fill: "url(#paint20_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5162 45.2395C12.6067 39.9758 12.459 34.7091 12.0532 29.4612C12.0438 29.3409 12.0729 29.2258 12.1651 29.1447C12.3041 29.0228 12.5043 29.0367 12.6747 29.0367C12.897 29.0367 13.0994 29.2238 13.0904 29.4568C12.885 34.7165 13.0846 39.9909 13.5533 45.2311C13.5642 45.3504 13.537 45.4646 13.4467 45.5461C13.3079 45.6711 13.1037 45.6568 12.9321 45.6568C12.7093 45.6568 12.5228 45.4719 12.5162 45.2445V45.2417V45.2395ZM22.3269 45.2445C22.3203 45.4721 22.1338 45.6568 21.9109 45.6568C21.8304 45.6568 21.7533 45.6608 21.6727 45.6522C21.434 45.6274 21.2658 45.4989 21.2896 45.2313C21.7584 39.9911 21.958 34.7165 21.7529 29.457C21.7437 29.224 21.9461 29.0369 22.1686 29.0369C22.2487 29.0369 22.3259 29.0333 22.4062 29.0417C22.6436 29.0667 22.8104 29.1959 22.7899 29.4612C22.3839 34.7091 22.2366 39.9758 22.3271 45.2395V45.2419L22.3269 45.2445Z",
    fill: "#BBBDBF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6245 45.2462C12.7145 40.0692 12.568 34.8922 12.161 29.7152C12.1346 29.3794 12.5014 29.4152 12.6746 29.4152C12.8386 29.4152 12.9887 29.5506 12.9819 29.7152C12.7803 34.7969 12.9666 39.9825 13.4456 45.2462C13.476 45.582 13.1048 45.5464 12.932 45.5464C12.7674 45.5464 12.6294 45.4112 12.6245 45.2462ZM22.2188 45.2462C22.1281 40.0692 22.2749 34.8922 22.682 29.7152C22.7085 29.3794 22.3417 29.4152 22.1687 29.4152C22.0045 29.4152 21.8546 29.5506 21.8609 29.7152C22.0629 34.7969 21.8762 39.9825 21.3977 45.2462C21.3671 45.582 21.738 45.5464 21.911 45.5464C22.0754 45.5464 22.2136 45.4112 22.2188 45.2462Z",
    fill: "#F2F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6082 10.3828C13.7921 11.5264 13.9619 12.8595 14.0966 14.283C14.2316 15.7069 14.3146 17.04 14.3474 18.1834C14.1636 17.04 13.9941 15.7069 13.8593 14.283C13.7245 12.8595 13.6414 11.5264 13.6082 10.3828ZM21.2342 10.3828C21.0507 11.5264 20.8809 12.8595 20.7459 14.283C20.6109 15.7069 20.5284 17.04 20.4954 18.1834C20.6793 17.04 20.8483 15.7069 20.9833 14.283C21.1183 12.8595 21.2014 11.5264 21.2342 10.3828Z",
    fill: "#DBDCDD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.2345,
    y1: 40.4571,
    x2: 25.2345,
    y2: 45.9099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.60864,
    y1: 40.4581,
    x2: 9.60864,
    y2: 45.9108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.6948,
    y1: 15.1162,
    x2: 25.6948,
    y2: 20.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.14791,
    y1: 15.1167,
    x2: 9.14791,
    y2: 20.5698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 25.7996,
    y1: 29.6006,
    x2: 9.04332,
    y2: 29.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 24.9696,
    y1: 14.3929,
    x2: 9.87331,
    y2: 14.3929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8804 29.148) scale(9.38425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8975 29.0764) scale(10.6216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 17.4216,
    y1: 34.2452,
    x2: 17.4216,
    y2: 17.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 11.0261,
    y1: 35.9402,
    x2: 10.3599,
    y2: 35.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 11.1046,
    y1: 42.335,
    x2: 10.4922,
    y2: 42.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 24.4829,
    y1: 35.9402,
    x2: 23.8167,
    y2: 35.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 24.3454,
    y1: 42.335,
    x2: 23.7659,
    y2: 42.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 24.6619,
    y1: 27.262,
    x2: 23.8615,
    y2: 27.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 10.9812,
    y1: 27.262,
    x2: 10.1808,
    y2: 27.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2906 44.5109) scale(7.50852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 9.79823,
    y1: 31.6007,
    x2: 9.77976,
    y2: 30.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 9.94611,
    y1: 39.1386,
    x2: 9.92764,
    y2: 38.0812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 25.0627,
    y1: 30.5429,
    x2: 25.0443,
    y2: 31.6009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 24.916,
    y1: 38.0821,
    x2: 24.8976,
    y2: 39.1398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 23.2005,
    y1: 36.7545,
    x2: 11.6428,
    y2: 36.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenced);
export default __webpack_public_path__ + "static/media/fenced.8db7f895d258e690085e0dc5bd4dce41.svg";
export { ForwardRef as ReactComponent };